!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("universal-websocket-client")) : "function" == typeof define && define.amd ? define("alphapoint", ["universal-websocket-client"], e) : "object" == typeof exports ? exports.alphapoint = e(require("universal-websocket-client")) : t.alphapoint = e(t.WebSocket);
}(this, function (t) {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }
    var r = {};
    return e.m = t, e.c = r, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 64);
  }([function (t, e) {
    var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = r);
  }, function (t, e) {
    var r = t.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = r);
  }, function (t, e, r) {
    var n = r(43)("wks"),
      o = r(44),
      i = r(0).Symbol,
      s = "function" == typeof i;
    (t.exports = function (t) {
      return n[t] || (n[t] = s && i[t] || (s ? i : o)("Symbol." + t));
    }).store = n;
  }, function (t, e, r) {
    "use strict";

    e.__esModule = !0, e.default = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t instanceof a || "syncErrorThrowable" in t && t[c.rxSubscriber];
    }
    var o = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      i = r(58),
      s = r(14),
      u = r(60),
      c = r(35),
      a = function (t) {
        function e(e, r, o) {
          switch (t.call(this), this.syncErrorValue = null, this.syncErrorThrown = !1, this.syncErrorThrowable = !1, this.isStopped = !1, arguments.length) {
            case 0:
              this.destination = u.empty;
              break;
            case 1:
              if (!e) {
                this.destination = u.empty;
                break;
              }
              if ("object" == typeof e) {
                if (n(e)) {
                  var i = e[c.rxSubscriber]();
                  this.syncErrorThrowable = i.syncErrorThrowable, this.destination = i, i.add(this);
                } else this.syncErrorThrowable = !0, this.destination = new l(this, e);
                break;
              }
            default:
              this.syncErrorThrowable = !0, this.destination = new l(this, e, r, o);
          }
        }
        return o(e, t), e.prototype[c.rxSubscriber] = function () {
          return this;
        }, e.create = function (t, r, n) {
          var o = new e(t, r, n);
          return o.syncErrorThrowable = !1, o;
        }, e.prototype.next = function (t) {
          this.isStopped || this._next(t);
        }, e.prototype.error = function (t) {
          this.isStopped || (this.isStopped = !0, this._error(t));
        }, e.prototype.complete = function () {
          this.isStopped || (this.isStopped = !0, this._complete());
        }, e.prototype.unsubscribe = function () {
          this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this));
        }, e.prototype._next = function (t) {
          this.destination.next(t);
        }, e.prototype._error = function (t) {
          this.destination.error(t), this.unsubscribe();
        }, e.prototype._complete = function () {
          this.destination.complete(), this.unsubscribe();
        }, e.prototype._unsubscribeAndRecycle = function () {
          var t = this,
            e = t._parent,
            r = t._parents;
          return this._parent = null, this._parents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parent = e, this._parents = r, this;
        }, e;
      }(s.Subscription);
    e.Subscriber = a;
    var l = function (t) {
      function e(e, r, n, o) {
        t.call(this), this._parentSubscriber = e;
        var s,
          c = this;
        i.isFunction(r) ? s = r : r && (s = r.next, n = r.error, o = r.complete, r !== u.empty && (c = Object.create(r), i.isFunction(c.unsubscribe) && this.add(c.unsubscribe.bind(c)), c.unsubscribe = this.unsubscribe.bind(this))), this._context = c, this._next = s, this._error = n, this._complete = o;
      }
      return o(e, t), e.prototype.next = function (t) {
        if (!this.isStopped && this._next) {
          var e = this._parentSubscriber;
          e.syncErrorThrowable ? this.__tryOrSetError(e, this._next, t) && this.unsubscribe() : this.__tryOrUnsub(this._next, t);
        }
      }, e.prototype.error = function (t) {
        if (!this.isStopped) {
          var e = this._parentSubscriber;
          if (this._error) e.syncErrorThrowable ? (this.__tryOrSetError(e, this._error, t), this.unsubscribe()) : (this.__tryOrUnsub(this._error, t), this.unsubscribe());else {
            if (!e.syncErrorThrowable) throw this.unsubscribe(), t;
            e.syncErrorValue = t, e.syncErrorThrown = !0, this.unsubscribe();
          }
        }
      }, e.prototype.complete = function () {
        var t = this;
        if (!this.isStopped) {
          var e = this._parentSubscriber;
          if (this._complete) {
            var r = function r() {
              return t._complete.call(t._context);
            };
            e.syncErrorThrowable ? (this.__tryOrSetError(e, r), this.unsubscribe()) : (this.__tryOrUnsub(r), this.unsubscribe());
          } else this.unsubscribe();
        }
      }, e.prototype.__tryOrUnsub = function (t, e) {
        try {
          t.call(this._context, e);
        } catch (t) {
          throw this.unsubscribe(), t;
        }
      }, e.prototype.__tryOrSetError = function (t, e, r) {
        try {
          e.call(this._context, r);
        } catch (e) {
          return t.syncErrorValue = e, t.syncErrorThrown = !0, !0;
        }
        return !1;
      }, e.prototype._unsubscribe = function () {
        var t = this._parentSubscriber;
        this._context = null, this._parentSubscriber = null, t.unsubscribe();
      }, e;
    }(a);
  }, function (t, e, r) {
    "use strict";

    var n = r(13),
      o = r(99),
      i = r(103),
      s = r(104),
      u = function () {
        function t(t) {
          this._isScalar = !1, t && (this._subscribe = t);
        }
        return t.prototype.lift = function (e) {
          var r = new t();
          return r.source = this, r.operator = e, r;
        }, t.prototype.subscribe = function (t, e, r) {
          var n = this.operator,
            i = o.toSubscriber(t, e, r);
          if (n ? n.call(i, this.source) : i.add(this.source || !i.syncErrorThrowable ? this._subscribe(i) : this._trySubscribe(i)), i.syncErrorThrowable && (i.syncErrorThrowable = !1, i.syncErrorThrown)) throw i.syncErrorValue;
          return i;
        }, t.prototype._trySubscribe = function (t) {
          try {
            return this._subscribe(t);
          } catch (e) {
            t.syncErrorThrown = !0, t.syncErrorValue = e, t.error(e);
          }
        }, t.prototype.forEach = function (t, e) {
          var r = this;
          if (e || (n.root.Rx && n.root.Rx.config && n.root.Rx.config.Promise ? e = n.root.Rx.config.Promise : n.root.Promise && (e = n.root.Promise)), !e) throw new Error("no Promise impl found");
          return new e(function (e, n) {
            var o;
            o = r.subscribe(function (e) {
              if (o) try {
                t(e);
              } catch (t) {
                n(t), o.unsubscribe();
              } else t(e);
            }, n, e);
          });
        }, t.prototype._subscribe = function (t) {
          return this.source.subscribe(t);
        }, t.prototype[i.observable] = function () {
          return this;
        }, t.prototype.pipe = function () {
          for (var t = [], e = 0; e < arguments.length; e++) t[e - 0] = arguments[e];
          return 0 === t.length ? this : s.pipeFromArray(t)(this);
        }, t.prototype.toPromise = function (t) {
          var e = this;
          if (t || (n.root.Rx && n.root.Rx.config && n.root.Rx.config.Promise ? t = n.root.Rx.config.Promise : n.root.Promise && (t = n.root.Promise)), !t) throw new Error("no Promise impl found");
          return new t(function (t, r) {
            var n;
            e.subscribe(function (t) {
              return n = t;
            }, function (t) {
              return r(t);
            }, function () {
              return t(n);
            });
          });
        }, t.create = function (e) {
          return new t(e);
        }, t;
      }();
    e.Observable = u;
  }, function (t, e, r) {
    var n = r(0),
      o = r(1),
      i = r(16),
      s = r(11),
      u = r(20),
      c = function c(t, e, r) {
        var a,
          l,
          f,
          d = t & c.F,
          h = t & c.G,
          p = t & c.S,
          v = t & c.P,
          b = t & c.B,
          y = t & c.W,
          _ = h ? o : o[e] || (o[e] = {}),
          O = _.prototype,
          S = h ? n : p ? n[e] : (n[e] || {}).prototype;
        h && (r = e);
        for (a in r) (l = !d && S && void 0 !== S[a]) && u(_, a) || (f = l ? S[a] : r[a], _[a] = h && "function" != typeof S[a] ? r[a] : b && l ? i(f, n) : y && S[a] == f ? function (t) {
          var e = function e(_e, r, n) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();
                case 1:
                  return new t(_e);
                case 2:
                  return new t(_e, r);
              }
              return new t(_e, r, n);
            }
            return t.apply(this, arguments);
          };
          return e.prototype = t.prototype, e;
        }(f) : v && "function" == typeof f ? i(Function.call, f) : f, v && ((_.virtual || (_.virtual = {}))[a] = f, t & c.R && O && !O[a] && s(O, a, f)));
      };
    c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, t.exports = c;
  }, function (t, e, r) {
    var n = r(17);
    t.exports = function (t) {
      if (!n(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e, r) {
    t.exports = !r(25)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(5),
      i = r(4),
      s = r(14),
      u = r(61),
      c = r(62),
      a = r(35),
      l = function (t) {
        function e(e) {
          t.call(this, e), this.destination = e;
        }
        return n(e, t), e;
      }(i.Subscriber);
    e.SubjectSubscriber = l;
    var f = function (t) {
      function e() {
        t.call(this), this.observers = [], this.closed = !1, this.isStopped = !1, this.hasError = !1, this.thrownError = null;
      }
      return n(e, t), e.prototype[a.rxSubscriber] = function () {
        return new l(this);
      }, e.prototype.lift = function (t) {
        var e = new d(this, this);
        return e.operator = t, e;
      }, e.prototype.next = function (t) {
        if (this.closed) throw new u.ObjectUnsubscribedError();
        if (!this.isStopped) for (var e = this.observers, r = e.length, n = e.slice(), o = 0; o < r; o++) n[o].next(t);
      }, e.prototype.error = function (t) {
        if (this.closed) throw new u.ObjectUnsubscribedError();
        this.hasError = !0, this.thrownError = t, this.isStopped = !0;
        for (var e = this.observers, r = e.length, n = e.slice(), o = 0; o < r; o++) n[o].error(t);
        this.observers.length = 0;
      }, e.prototype.complete = function () {
        if (this.closed) throw new u.ObjectUnsubscribedError();
        this.isStopped = !0;
        for (var t = this.observers, e = t.length, r = t.slice(), n = 0; n < e; n++) r[n].complete();
        this.observers.length = 0;
      }, e.prototype.unsubscribe = function () {
        this.isStopped = !0, this.closed = !0, this.observers = null;
      }, e.prototype._trySubscribe = function (e) {
        if (this.closed) throw new u.ObjectUnsubscribedError();
        return t.prototype._trySubscribe.call(this, e);
      }, e.prototype._subscribe = function (t) {
        if (this.closed) throw new u.ObjectUnsubscribedError();
        return this.hasError ? (t.error(this.thrownError), s.Subscription.EMPTY) : this.isStopped ? (t.complete(), s.Subscription.EMPTY) : (this.observers.push(t), new c.SubjectSubscription(this, t));
      }, e.prototype.asObservable = function () {
        var t = new o.Observable();
        return t.source = this, t;
      }, e.create = function (t, e) {
        return new d(t, e);
      }, e;
    }(o.Observable);
    e.Subject = f;
    var d = function (t) {
      function e(e, r) {
        t.call(this), this.destination = e, this.source = r;
      }
      return n(e, t), e.prototype.next = function (t) {
        var e = this.destination;
        e && e.next && e.next(t);
      }, e.prototype.error = function (t) {
        var e = this.destination;
        e && e.error && this.destination.error(t);
      }, e.prototype.complete = function () {
        var t = this.destination;
        t && t.complete && this.destination.complete();
      }, e.prototype._subscribe = function (t) {
        return this.source ? this.source.subscribe(t) : s.Subscription.EMPTY;
      }, e;
    }(f);
    e.AnonymousSubject = d;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.Order = e.Trade = e.Level2 = e.Level1 = void 0;
    var o = r(121),
      i = n(o),
      s = r(127),
      u = n(s),
      c = r(128),
      a = n(c),
      l = r(129),
      f = n(l);
    e.Level1 = i.default, e.Level2 = u.default, e.Trade = a.default, e.Order = f.default;
  }, function (t, e, r) {
    var n = r(12),
      o = r(27);
    t.exports = r(8) ? function (t, e, r) {
      return n.f(t, e, o(1, r));
    } : function (t, e, r) {
      return t[e] = r, t;
    };
  }, function (t, e, r) {
    var n = r(7),
      o = r(70),
      i = r(71),
      s = Object.defineProperty;
    e.f = r(8) ? Object.defineProperty : function (t, e, r) {
      if (n(t), e = i(e, !0), n(r), o) try {
        return s(t, e, r);
      } catch (t) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
      return "value" in r && (t[e] = r.value), t;
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      var r = "undefined" != typeof window && window,
        n = "undefined" != typeof self && "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && self,
        o = void 0 !== t && t,
        i = r || o || n;
      e.root = i, function () {
        if (!i) throw new Error("RxJS could not find any global context (window, self, global)");
      }();
    }).call(e, r(98));
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t.reduce(function (t, e) {
        return t.concat(e instanceof a.UnsubscriptionError ? e.errors : e);
      }, []);
    }
    var o = r(100),
      i = r(101),
      s = r(58),
      u = r(59),
      c = r(34),
      a = r(102),
      l = function () {
        function t(t) {
          this.closed = !1, this._parent = null, this._parents = null, this._subscriptions = null, t && (this._unsubscribe = t);
        }
        return t.prototype.unsubscribe = function () {
          var t,
            e = !1;
          if (!this.closed) {
            var r = this,
              l = r._parent,
              f = r._parents,
              d = r._unsubscribe,
              h = r._subscriptions;
            this.closed = !0, this._parent = null, this._parents = null, this._subscriptions = null;
            for (var p = -1, v = f ? f.length : 0; l;) l.remove(this), l = ++p < v && f[p] || null;
            if (s.isFunction(d)) {
              var b = u.tryCatch(d).call(this);
              b === c.errorObject && (e = !0, t = t || (c.errorObject.e instanceof a.UnsubscriptionError ? n(c.errorObject.e.errors) : [c.errorObject.e]));
            }
            if (o.isArray(h)) for (p = -1, v = h.length; ++p < v;) {
              var y = h[p];
              if (i.isObject(y)) {
                var b = u.tryCatch(y.unsubscribe).call(y);
                if (b === c.errorObject) {
                  e = !0, t = t || [];
                  var _ = c.errorObject.e;
                  _ instanceof a.UnsubscriptionError ? t = t.concat(n(_.errors)) : t.push(_);
                }
              }
            }
            if (e) throw new a.UnsubscriptionError(t);
          }
        }, t.prototype.add = function (e) {
          if (!e || e === t.EMPTY) return t.EMPTY;
          if (e === this) return this;
          var r = e;
          switch (typeof e) {
            case "function":
              r = new t(e);
            case "object":
              if (r.closed || "function" != typeof r.unsubscribe) return r;
              if (this.closed) return r.unsubscribe(), r;
              if ("function" != typeof r._addParent) {
                var n = r;
                r = new t(), r._subscriptions = [n];
              }
              break;
            default:
              throw new Error("unrecognized teardown " + e + " added to Subscription.");
          }
          return (this._subscriptions || (this._subscriptions = [])).push(r), r._addParent(this), r;
        }, t.prototype.remove = function (t) {
          var e = this._subscriptions;
          if (e) {
            var r = e.indexOf(t);
            -1 !== r && e.splice(r, 1);
          }
        }, t.prototype._addParent = function (t) {
          var e = this,
            r = e._parent,
            n = e._parents;
          r && r !== t ? n ? -1 === n.indexOf(t) && n.push(t) : this._parents = [t] : this._parent = t;
        }, t.EMPTY = function (t) {
          return t.closed = !0, t;
        }(new t()), t;
      }();
    e.Subscription = l;
  }, function (t, e, r) {
    "use strict";

    var n = r(5),
      o = r(119);
    n.Observable.prototype.filter = o.filter;
  }, function (t, e, r) {
    var n = r(19);
    t.exports = function (t, e, r) {
      if (n(t), void 0 === e) return t;
      switch (r) {
        case 1:
          return function (r) {
            return t.call(e, r);
          };
        case 2:
          return function (r, n) {
            return t.call(e, r, n);
          };
        case 3:
          return function (r, n, o) {
            return t.call(e, r, n, o);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e) {
    var r = {}.hasOwnProperty;
    t.exports = function (t, e) {
      return r.call(t, e);
    };
  }, function (t, e) {
    var r = {}.toString;
    t.exports = function (t) {
      return r.call(t).slice(8, -1);
    };
  }, function (t, e) {
    var r = Math.ceil,
      n = Math.floor;
    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? n : r)(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e) {
    t.exports = !0;
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, r) {
    var n = r(17),
      o = r(0).document,
      i = n(o) && n(o.createElement);
    t.exports = function (t) {
      return i ? o.createElement(t) : {};
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e, r) {
    var n = r(42),
      o = r(23);
    t.exports = function (t) {
      return n(o(t));
    };
  }, function (t, e, r) {
    var n = r(22),
      o = Math.min;
    t.exports = function (t) {
      return t > 0 ? o(n(t), 9007199254740991) : 0;
    };
  }, function (t, e, r) {
    var n = r(43)("keys"),
      o = r(44);
    t.exports = function (t) {
      return n[t] || (n[t] = o(t));
    };
  }, function (t, e, r) {
    var n = r(12).f,
      o = r(20),
      i = r(2)("toStringTag");
    t.exports = function (t, e, r) {
      t && !o(t = r ? t : t.prototype, i) && n(t, i, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, r) {
    var n = r(23);
    t.exports = function (t) {
      return Object(n(t));
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e, r;
      this.promise = new t(function (t, n) {
        if (void 0 !== e || void 0 !== r) throw TypeError("Bad Promise constructor");
        e = t, r = n;
      }), this.resolve = o(e), this.reject = o(r);
    }
    var o = r(19);
    t.exports.f = function (t) {
      return new n(t);
    };
  }, function (t, e, r) {
    "use strict";

    e.errorObject = {
      e: {}
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(13),
      o = n.root.Symbol;
    e.rxSubscriber = "function" == typeof o && "function" == typeof o.for ? o.for("rxSubscriber") : "@@rxSubscriber", e.$$rxSubscriber = e.rxSubscriber;
  }, function (t, e, r) {
    t.exports = {
      default: r(122),
      __esModule: !0
    };
  }, function (t, e, r) {
    t.exports = {
      default: r(66),
      __esModule: !0
    };
  }, function (t, e, r) {
    t.exports = {
      default: r(67),
      __esModule: !0
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(69)(!0);
    r(40)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
        e = this._t,
        r = this._i;
      return r >= e.length ? {
        value: void 0,
        done: !0
      } : (t = n(e, r), this._i += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(24),
      o = r(6),
      i = r(72),
      s = r(11),
      u = r(18),
      c = r(73),
      a = r(31),
      l = r(79),
      f = r(2)("iterator"),
      d = !([].keys && "next" in [].keys()),
      h = function h() {
        return this;
      };
    t.exports = function (t, e, r, p, v, b, y) {
      c(r, e, p);
      var _,
        O,
        S,
        g = function g(t) {
          if (!d && t in P) return P[t];
          switch (t) {
            case "keys":
            case "values":
              return function () {
                return new r(this, t);
              };
          }
          return function () {
            return new r(this, t);
          };
        },
        m = e + " Iterator",
        A = "values" == v,
        w = !1,
        P = t.prototype,
        x = P[f] || P["@@iterator"] || v && P[v],
        I = x || g(v),
        C = v ? A ? g("entries") : I : void 0,
        M = "Array" == e ? P.entries || x : x;
      if (M && (S = l(M.call(new t()))) !== Object.prototype && S.next && (a(S, m, !0), n || "function" == typeof S[f] || s(S, f, h)), A && x && "values" !== x.name && (w = !0, I = function I() {
        return x.call(this);
      }), n && !y || !d && !w && P[f] || s(P, f, I), u[e] = I, u[m] = h, v) if (_ = {
        values: A ? I : g("values"),
        keys: b ? I : g("keys"),
        entries: C
      }, y) for (O in _) O in P || i(P, O, _[O]);else o(o.P + o.F * (d || w), e, _);
      return _;
    };
  }, function (t, e, r) {
    var n = r(76),
      o = r(45);
    t.exports = Object.keys || function (t) {
      return n(t, o);
    };
  }, function (t, e, r) {
    var n = r(21);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == n(t) ? t.split("") : Object(t);
    };
  }, function (t, e, r) {
    var n = r(1),
      o = r(0),
      i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
    (t.exports = function (t, e) {
      return i[t] || (i[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: n.version,
      mode: r(24) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e) {
    var r = 0,
      n = Math.random();
    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + n).toString(36));
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, r) {
    var n = r(0).document;
    t.exports = n && n.documentElement;
  }, function (t, e, r) {
    var n = r(21),
      o = r(2)("toStringTag"),
      i = "Arguments" == n(function () {
        return arguments;
      }()),
      s = function s(t, e) {
        try {
          return t[e];
        } catch (t) {}
      };
    t.exports = function (t) {
      var e, r, u;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = s(e = Object(t), o)) ? r : i ? n(e) : "Object" == (u = n(e)) && "function" == typeof e.callee ? "Arguments" : u;
    };
  }, function (t, e, r) {
    var n = r(7);
    t.exports = function (t, e, r, o) {
      try {
        return o ? e(n(r)[0], r[1]) : e(r);
      } catch (e) {
        var i = t.return;
        throw void 0 !== i && n(i.call(t)), e;
      }
    };
  }, function (t, e, r) {
    var n = r(18),
      o = r(2)("iterator"),
      i = Array.prototype;
    t.exports = function (t) {
      return void 0 !== t && (n.Array === t || i[o] === t);
    };
  }, function (t, e, r) {
    var n = r(47),
      o = r(2)("iterator"),
      i = r(18);
    t.exports = r(1).getIteratorMethod = function (t) {
      if (void 0 != t) return t[o] || t["@@iterator"] || i[n(t)];
    };
  }, function (t, e, r) {
    var n = r(7),
      o = r(19),
      i = r(2)("species");
    t.exports = function (t, e) {
      var r,
        s = n(t).constructor;
      return void 0 === s || void 0 == (r = n(s)[i]) ? e : o(r);
    };
  }, function (t, e, r) {
    var n,
      o,
      i,
      s = r(16),
      u = r(87),
      c = r(46),
      a = r(26),
      l = r(0),
      f = l.process,
      d = l.setImmediate,
      h = l.clearImmediate,
      p = l.MessageChannel,
      v = l.Dispatch,
      b = 0,
      y = {},
      _ = function _() {
        var t = +this;
        if (y.hasOwnProperty(t)) {
          var e = y[t];
          delete y[t], e();
        }
      },
      O = function O(t) {
        _.call(t.data);
      };
    d && h || (d = function d(t) {
      for (var e = [], r = 1; arguments.length > r;) e.push(arguments[r++]);
      return y[++b] = function () {
        u("function" == typeof t ? t : Function(t), e);
      }, n(b), b;
    }, h = function h(t) {
      delete y[t];
    }, "process" == r(21)(f) ? n = function n(t) {
      f.nextTick(s(_, t, 1));
    } : v && v.now ? n = function n(t) {
      v.now(s(_, t, 1));
    } : p ? (o = new p(), i = o.port2, o.port1.onmessage = O, n = s(i.postMessage, i, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts ? (n = function n(t) {
      l.postMessage(t + "", "*");
    }, l.addEventListener("message", O, !1)) : n = "onreadystatechange" in a("script") ? function (t) {
      c.appendChild(a("script")).onreadystatechange = function () {
        c.removeChild(this), _.call(t);
      };
    } : function (t) {
      setTimeout(s(_, t, 1), 0);
    }), t.exports = {
      set: d,
      clear: h
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    };
  }, function (t, e, r) {
    var n = r(7),
      o = r(17),
      i = r(33);
    t.exports = function (t, e) {
      if (n(t), o(e) && e.constructor === t) return e;
      var r = i.f(t);
      return (0, r.resolve)(e), r.promise;
    };
  }, function (t, e, r) {
    var n = r(2)("iterator"),
      o = !1;
    try {
      var i = [7][n]();
      i.return = function () {
        o = !0;
      }, Array.from(i, function () {
        throw 2;
      });
    } catch (t) {}
    t.exports = function (t, e) {
      if (!e && !o) return !1;
      var r = !1;
      try {
        var i = [7],
          s = i[n]();
        s.next = function () {
          return {
            done: r = !0
          };
        }, i[n] = function () {
          return s;
        }, t(i);
      } catch (t) {}
      return r;
    };
  }, function (t, e, r) {
    "use strict";

    e.__esModule = !0;
    var n = r(94),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n);
    e.default = function () {
      function t(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, o.default)(t, n.key, n);
        }
      }
      return function (e, r, n) {
        return r && t(e.prototype, r), n && t(e, n), e;
      };
    }();
  }, function (t, e, r) {
    "use strict";

    var n = r(97);
    e.webSocket = n.WebSocketSubject.create;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return "function" == typeof t;
    }
    e.isFunction = n;
  }, function (t, e, r) {
    "use strict";

    function n() {
      try {
        return i.apply(this, arguments);
      } catch (t) {
        return s.errorObject.e = t, s.errorObject;
      }
    }
    function o(t) {
      return i = t, n;
    }
    var i,
      s = r(34);
    e.tryCatch = o;
  }, function (t, e, r) {
    "use strict";

    e.empty = {
      closed: !0,
      next: function next(t) {},
      error: function error(t) {
        throw t;
      },
      complete: function complete() {}
    };
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = function (t) {
        function e() {
          var e = t.call(this, "object unsubscribed");
          this.name = e.name = "ObjectUnsubscribedError", this.stack = e.stack, this.message = e.message;
        }
        return n(e, t), e;
      }(Error);
    e.ObjectUnsubscribedError = o;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(14),
      i = function (t) {
        function e(e, r) {
          t.call(this), this.subject = e, this.subscriber = r, this.closed = !1;
        }
        return n(e, t), e.prototype.unsubscribe = function () {
          if (!this.closed) {
            this.closed = !0;
            var t = this.subject,
              e = t.observers;
            if (this.subject = null, e && 0 !== e.length && !t.isStopped && !t.closed) {
              var r = e.indexOf(this.subscriber);
              -1 !== r && e.splice(r, 1);
            }
          }
        }, e;
      }(o.Subscription);
    e.SubjectSubscription = i;
  }, function (e, r) {
    e.exports = t;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.Order = e.Trade = e.Level2 = e.Level1 = e.APAD = e.APEX = void 0;
    var n = r(65),
      o = r(175),
      i = r(10),
      s = {
        APEX: n.APEX,
        APAD: o.APAD
      };
    e.default = s, e.APEX = n.APEX, e.APAD = o.APAD, e.Level1 = i.Level1, e.Level2 = i.Level2, e.Trade = i.Trade, e.Order = i.Order;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.APEX = void 0;
    var o = r(37),
      i = n(o),
      s = r(38),
      u = n(s),
      c = r(3),
      a = n(c),
      l = r(56),
      f = n(l),
      d = r(57),
      h = r(117),
      p = r(137),
      v = r(143),
      b = r(63),
      y = function () {
        function t() {
          var e = this,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "ws://demo.alphapoint.com:8086/WSGateway/",
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              onopen: function onopen() {},
              onclose: function onclose() {}
            };
          (0, a.default)(this, t), this.getProducts = v.getProducts, this.getInstruments = v.getInstruments, this.authenticateUser = v.authenticateUser, this.webAuthenticateUser = v.webAuthenticateUser, this.sendOrder = v.sendOrder, this.cancelOrder = v.cancelOrder, this.cancelAllOrders = v.cancelAllOrders, this.getOMSs = v.getOMSs, this.getUserInfo = v.getUserInfo, this.getUserPermissions = v.getUserPermissions, this.getUserAccounts = v.getUserAccounts, this.getAccountInfo = v.getAccountInfo, this.getAccountTransactions = v.getAccountTransactions, this.getRequestTransfers = v.getRequestTransfers, this.getWithdrawTickets = v.getWithdrawTickets, this.getOpenTradeReports = v.getOpenTradeReports, this.getOpenOrders = v.getOpenOrders, this.getOpenQuotes = v.getOpenQuotes, this.getAccountPositions = v.getAccountPositions, this.getOrderHistory = v.getOrderHistory, this.getAccountTrades = v.getAccountTrades, this.getUserAPIKeys = v.getUserAPIKeys, this.getUserConfig = v.getUserConfig, this.getOrderFee = v.getOrderFee, this.subscribeLevel1 = v.subscribeLevel1, this.unsubscribeLevel1 = v.unsubscribeLevel1, this.subscribeLevel2 = v.subscribeLevel2, this.unsubscribeLevel2 = v.unsubscribeLevel2, this.subscribeTrades = v.subscribeTrades, this.unsubscribeTrades = v.unsubscribeTrades, this.subscribeAccountEvents = v.subscribeAccountEvents, this.seq = 0, this.ws = (0, d.webSocket)({
            url: r,
            WebSocketCtor: b,
            openObserver: {
              next: function next(t) {
                return n.onopen(t);
              }
            },
            closeObserver: {
              next: function next(t) {
                return n.onclose(t);
              }
            }
          }), this.ws.subscribe(function (t) {
            e.callbacks[t.i] && 1 === t.m && (e.callbacks[t.i](t), delete e.callbacks[t.i]);
          }, function (t) {
            return console.log(t);
          }, function () {
            return console.log("completes");
          }), this.standardCallback = function (t) {
            return console.log(t);
          }, this.omsId = 1, this.accountId, this.callbacks = {}, this.isAuthenticated = !1, this.level1 = new h.Level1Subject(this), this.level2 = new h.Level2Subject(this), this.trades = new h.TradesSubject(this), this.accountEvents = new h.AccountEventsSubject(this), this.orderEvents = new h.OrderEventSubject(this), p.endpoints.forEach(function (t) {
            e[t] = function () {
              var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                OMSId: 1
              };
              return new u.default(function (n, o) {
                e.RPCCall(t, r, function (t) {
                  if (5 === t.m) o(t);else try {
                    var e = JSON.parse(t.o);
                    n(e);
                  } catch (e) {
                    n(t.o ? t.o : t);
                  }
                });
              });
            };
          });
        }
        return (0, f.default)(t, [{
          key: "RPCCall",
          value: function value(t, e) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.standardCallback,
              n = {
                m: 0,
                i: this.seq,
                n: t,
                o: (0, i.default)(e)
              };
            this.callbacks[this.seq] = r, this.seq += 2, this.ws.next((0, i.default)(n));
          }
        }, {
          key: "RPCPromise",
          value: function value(t, e) {
            var r = this;
            return new u.default(function (n, o) {
              r.RPCCall(t, e, function (t) {
                5 === t.m ? o(t) : n(t);
              });
            });
          }
        }, {
          key: "closeConnection",
          value: function value() {
            this.ws.socket.close();
          }
        }]), t;
      }();
    e.APEX = y;
  }, function (t, e, r) {
    var n = r(1),
      o = n.JSON || (n.JSON = {
        stringify: JSON.stringify
      });
    t.exports = function (t) {
      return o.stringify.apply(o, arguments);
    };
  }, function (t, e, r) {
    r(68), r(39), r(80), r(84), r(92), r(93), t.exports = r(1).Promise;
  }, function (t, e) {}, function (t, e, r) {
    var n = r(22),
      o = r(23);
    t.exports = function (t) {
      return function (e, r) {
        var i,
          s,
          u = String(o(e)),
          c = n(r),
          a = u.length;
        return c < 0 || c >= a ? t ? "" : void 0 : (i = u.charCodeAt(c), i < 55296 || i > 56319 || c + 1 === a || (s = u.charCodeAt(c + 1)) < 56320 || s > 57343 ? t ? u.charAt(c) : i : t ? u.slice(c, c + 2) : s - 56320 + (i - 55296 << 10) + 65536);
      };
    };
  }, function (t, e, r) {
    t.exports = !r(8) && !r(25)(function () {
      return 7 != Object.defineProperty(r(26)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, r) {
    var n = r(17);
    t.exports = function (t, e) {
      if (!n(t)) return t;
      var r, o;
      if (e && "function" == typeof (r = t.toString) && !n(o = r.call(t))) return o;
      if ("function" == typeof (r = t.valueOf) && !n(o = r.call(t))) return o;
      if (!e && "function" == typeof (r = t.toString) && !n(o = r.call(t))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, r) {
    t.exports = r(11);
  }, function (t, e, r) {
    "use strict";

    var n = r(74),
      o = r(27),
      i = r(31),
      s = {};
    r(11)(s, r(2)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, r) {
      t.prototype = n(s, {
        next: o(1, r)
      }), i(t, e + " Iterator");
    };
  }, function (t, e, r) {
    var n = r(7),
      o = r(75),
      i = r(45),
      s = r(30)("IE_PROTO"),
      u = function u() {},
      _c = function c() {
        var t,
          e = r(26)("iframe"),
          n = i.length;
        for (e.style.display = "none", r(46).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _c = t.F; n--;) delete _c.prototype[i[n]];
        return _c();
      };
    t.exports = Object.create || function (t, e) {
      var r;
      return null !== t ? (u.prototype = n(t), r = new u(), u.prototype = null, r[s] = t) : r = _c(), void 0 === e ? r : o(r, e);
    };
  }, function (t, e, r) {
    var n = r(12),
      o = r(7),
      i = r(41);
    t.exports = r(8) ? Object.defineProperties : function (t, e) {
      o(t);
      for (var r, s = i(e), u = s.length, c = 0; u > c;) n.f(t, r = s[c++], e[r]);
      return t;
    };
  }, function (t, e, r) {
    var n = r(20),
      o = r(28),
      i = r(77)(!1),
      s = r(30)("IE_PROTO");
    t.exports = function (t, e) {
      var r,
        u = o(t),
        c = 0,
        a = [];
      for (r in u) r != s && n(u, r) && a.push(r);
      for (; e.length > c;) n(u, r = e[c++]) && (~i(a, r) || a.push(r));
      return a;
    };
  }, function (t, e, r) {
    var n = r(28),
      o = r(29),
      i = r(78);
    t.exports = function (t) {
      return function (e, r, s) {
        var u,
          c = n(e),
          a = o(c.length),
          l = i(s, a);
        if (t && r != r) {
          for (; a > l;) if ((u = c[l++]) != u) return !0;
        } else for (; a > l; l++) if ((t || l in c) && c[l] === r) return t || l || 0;
        return !t && -1;
      };
    };
  }, function (t, e, r) {
    var n = r(22),
      o = Math.max,
      i = Math.min;
    t.exports = function (t, e) {
      return t = n(t), t < 0 ? o(t + e, 0) : i(t, e);
    };
  }, function (t, e, r) {
    var n = r(20),
      o = r(32),
      i = r(30)("IE_PROTO"),
      s = Object.prototype;
    t.exports = Object.getPrototypeOf || function (t) {
      return t = o(t), n(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
    };
  }, function (t, e, r) {
    r(81);
    for (var n = r(0), o = r(11), i = r(18), s = r(2)("toStringTag"), u = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), c = 0; c < u.length; c++) {
      var a = u[c],
        l = n[a],
        f = l && l.prototype;
      f && !f[s] && o(f, s, a), i[a] = i.Array;
    }
  }, function (t, e, r) {
    "use strict";

    var n = r(82),
      o = r(83),
      i = r(18),
      s = r(28);
    t.exports = r(40)(Array, "Array", function (t, e) {
      this._t = s(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
        e = this._k,
        r = this._i++;
      return !t || r >= t.length ? (this._t = void 0, o(1)) : "keys" == e ? o(0, r) : "values" == e ? o(0, t[r]) : o(0, [r, t[r]]);
    }, "values"), i.Arguments = i.Array, n("keys"), n("values"), n("entries");
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n,
      o,
      i,
      s,
      u = r(24),
      c = r(0),
      a = r(16),
      l = r(47),
      f = r(6),
      d = r(17),
      h = r(19),
      p = r(85),
      v = r(86),
      b = r(51),
      y = r(52).set,
      _ = r(88)(),
      O = r(33),
      S = r(53),
      g = r(89),
      m = r(54),
      A = c.TypeError,
      w = c.process,
      P = w && w.versions,
      x = P && P.v8 || "",
      _I = c.Promise,
      C = "process" == l(w),
      M = function M() {},
      T = o = O.f,
      G = !!function () {
        try {
          var t = _I.resolve(1),
            e = (t.constructor = {})[r(2)("species")] = function (t) {
              t(M, M);
            };
          return (C || "function" == typeof PromiseRejectionEvent) && t.then(M) instanceof e && 0 !== x.indexOf("6.6") && -1 === g.indexOf("Chrome/66");
        } catch (t) {}
      }(),
      j = function j(t) {
        var e;
        return !(!d(t) || "function" != typeof (e = t.then)) && e;
      },
      E = function E(t, e) {
        if (!t._n) {
          t._n = !0;
          var r = t._c;
          _(function () {
            for (var n = t._v, o = 1 == t._s, i = 0; r.length > i;) !function (e) {
              var r,
                i,
                s,
                u = o ? e.ok : e.fail,
                c = e.resolve,
                a = e.reject,
                l = e.domain;
              try {
                u ? (o || (2 == t._h && U(t), t._h = 1), !0 === u ? r = n : (l && l.enter(), r = u(n), l && (l.exit(), s = !0)), r === e.promise ? a(A("Promise-chain cycle")) : (i = j(r)) ? i.call(r, c, a) : c(r)) : a(n);
              } catch (t) {
                l && !s && l.exit(), a(t);
              }
            }(r[i++]);
            t._c = [], t._n = !1, e && !t._h && R(t);
          });
        }
      },
      R = function R(t) {
        y.call(c, function () {
          var e,
            r,
            n,
            o = t._v,
            i = k(t);
          if (i && (e = S(function () {
            C ? w.emit("unhandledRejection", o, t) : (r = c.onunhandledrejection) ? r({
              promise: t,
              reason: o
            }) : (n = c.console) && n.error && n.error("Unhandled promise rejection", o);
          }), t._h = C || k(t) ? 2 : 1), t._a = void 0, i && e.e) throw e.v;
        });
      },
      k = function k(t) {
        return 1 !== t._h && 0 === (t._a || t._c).length;
      },
      U = function U(t) {
        y.call(c, function () {
          var e;
          C ? w.emit("rejectionHandled", t) : (e = c.onrejectionhandled) && e({
            promise: t,
            reason: t._v
          });
        });
      },
      L = function L(t) {
        var e = this;
        e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), E(e, !0));
      },
      F = function F(t) {
        var e,
          r = this;
        if (!r._d) {
          r._d = !0, r = r._w || r;
          try {
            if (r === t) throw A("Promise can't be resolved itself");
            (e = j(t)) ? _(function () {
              var n = {
                _w: r,
                _d: !1
              };
              try {
                e.call(t, a(F, n, 1), a(L, n, 1));
              } catch (t) {
                L.call(n, t);
              }
            }) : (r._v = t, r._s = 1, E(r, !1));
          } catch (t) {
            L.call({
              _w: r,
              _d: !1
            }, t);
          }
        }
      };
    G || (_I = function I(t) {
      p(this, _I, "Promise", "_h"), h(t), n.call(this);
      try {
        t(a(F, this, 1), a(L, this, 1));
      } catch (t) {
        L.call(this, t);
      }
    }, n = function n(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }, n.prototype = r(90)(_I.prototype, {
      then: function then(t, e) {
        var r = T(b(this, _I));
        return r.ok = "function" != typeof t || t, r.fail = "function" == typeof e && e, r.domain = C ? w.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && E(this, !1), r.promise;
      },
      catch: function _catch(t) {
        return this.then(void 0, t);
      }
    }), i = function i() {
      var t = new n();
      this.promise = t, this.resolve = a(F, t, 1), this.reject = a(L, t, 1);
    }, O.f = T = function T(t) {
      return t === _I || t === s ? new i(t) : o(t);
    }), f(f.G + f.W + f.F * !G, {
      Promise: _I
    }), r(31)(_I, "Promise"), r(91)("Promise"), s = r(1).Promise, f(f.S + f.F * !G, "Promise", {
      reject: function reject(t) {
        var e = T(this);
        return (0, e.reject)(t), e.promise;
      }
    }), f(f.S + f.F * (u || !G), "Promise", {
      resolve: function resolve(t) {
        return m(u && this === s ? _I : this, t);
      }
    }), f(f.S + f.F * !(G && r(55)(function (t) {
      _I.all(t).catch(M);
    })), "Promise", {
      all: function all(t) {
        var e = this,
          r = T(e),
          n = r.resolve,
          o = r.reject,
          i = S(function () {
            var r = [],
              i = 0,
              s = 1;
            v(t, !1, function (t) {
              var u = i++,
                c = !1;
              r.push(void 0), s++, e.resolve(t).then(function (t) {
                c || (c = !0, r[u] = t, --s || n(r));
              }, o);
            }), --s || n(r);
          });
        return i.e && o(i.v), r.promise;
      },
      race: function race(t) {
        var e = this,
          r = T(e),
          n = r.reject,
          o = S(function () {
            v(t, !1, function (t) {
              e.resolve(t).then(r.resolve, n);
            });
          });
        return o.e && n(o.v), r.promise;
      }
    });
  }, function (t, e) {
    t.exports = function (t, e, r, n) {
      if (!(t instanceof e) || void 0 !== n && n in t) throw TypeError(r + ": incorrect invocation!");
      return t;
    };
  }, function (t, e, r) {
    var n = r(16),
      o = r(48),
      i = r(49),
      s = r(7),
      u = r(29),
      c = r(50),
      a = {},
      l = {},
      e = t.exports = function (t, e, r, f, d) {
        var h,
          p,
          v,
          b,
          y = d ? function () {
            return t;
          } : c(t),
          _ = n(r, f, e ? 2 : 1),
          O = 0;
        if ("function" != typeof y) throw TypeError(t + " is not iterable!");
        if (i(y)) {
          for (h = u(t.length); h > O; O++) if ((b = e ? _(s(p = t[O])[0], p[1]) : _(t[O])) === a || b === l) return b;
        } else for (v = y.call(t); !(p = v.next()).done;) if ((b = o(v, _, p.value, e)) === a || b === l) return b;
      };
    e.BREAK = a, e.RETURN = l;
  }, function (t, e) {
    t.exports = function (t, e, r) {
      var n = void 0 === r;
      switch (e.length) {
        case 0:
          return n ? t() : t.call(r);
        case 1:
          return n ? t(e[0]) : t.call(r, e[0]);
        case 2:
          return n ? t(e[0], e[1]) : t.call(r, e[0], e[1]);
        case 3:
          return n ? t(e[0], e[1], e[2]) : t.call(r, e[0], e[1], e[2]);
        case 4:
          return n ? t(e[0], e[1], e[2], e[3]) : t.call(r, e[0], e[1], e[2], e[3]);
      }
      return t.apply(r, e);
    };
  }, function (t, e, r) {
    var n = r(0),
      o = r(52).set,
      i = n.MutationObserver || n.WebKitMutationObserver,
      s = n.process,
      u = n.Promise,
      c = "process" == r(21)(s);
    t.exports = function () {
      var t,
        e,
        r,
        a = function a() {
          var n, o;
          for (c && (n = s.domain) && n.exit(); t;) {
            o = t.fn, t = t.next;
            try {
              o();
            } catch (n) {
              throw t ? r() : e = void 0, n;
            }
          }
          e = void 0, n && n.enter();
        };
      if (c) r = function r() {
        s.nextTick(a);
      };else if (!i || n.navigator && n.navigator.standalone) {
        if (u && u.resolve) {
          var l = u.resolve(void 0);
          r = function r() {
            l.then(a);
          };
        } else r = function r() {
          o.call(n, a);
        };
      } else {
        var f = !0,
          d = document.createTextNode("");
        new i(a).observe(d, {
          characterData: !0
        }), r = function r() {
          d.data = f = !f;
        };
      }
      return function (n) {
        var o = {
          fn: n,
          next: void 0
        };
        e && (e.next = o), t || (t = o, r()), e = o;
      };
    };
  }, function (t, e, r) {
    var n = r(0),
      o = n.navigator;
    t.exports = o && o.userAgent || "";
  }, function (t, e, r) {
    var n = r(11);
    t.exports = function (t, e, r) {
      for (var o in e) r && t[o] ? t[o] = e[o] : n(t, o, e[o]);
      return t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
      o = r(1),
      i = r(12),
      s = r(8),
      u = r(2)("species");
    t.exports = function (t) {
      var e = "function" == typeof o[t] ? o[t] : n[t];
      s && e && !e[u] && i.f(e, u, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(6),
      o = r(1),
      i = r(0),
      s = r(51),
      u = r(54);
    n(n.P + n.R, "Promise", {
      finally: function _finally(t) {
        var e = s(this, o.Promise || i.Promise),
          r = "function" == typeof t;
        return this.then(r ? function (r) {
          return u(e, t()).then(function () {
            return r;
          });
        } : t, r ? function (r) {
          return u(e, t()).then(function () {
            throw r;
          });
        } : t);
      }
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(6),
      o = r(33),
      i = r(53);
    n(n.S, "Promise", {
      try: function _try(t) {
        var e = o.f(this),
          r = i(t);
        return (r.e ? e.reject : e.resolve)(r.v), e.promise;
      }
    });
  }, function (t, e, r) {
    t.exports = {
      default: r(95),
      __esModule: !0
    };
  }, function (t, e, r) {
    r(96);
    var n = r(1).Object;
    t.exports = function (t, e, r) {
      return n.defineProperty(t, e, r);
    };
  }, function (t, e, r) {
    var n = r(6);
    n(n.S + n.F * !r(8), "Object", {
      defineProperty: r(12).f
    });
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(9),
      i = r(4),
      s = r(5),
      u = r(14),
      c = r(13),
      a = r(106),
      l = r(59),
      f = r(34),
      d = r(116),
      h = function (t) {
        function e(e, r) {
          if (e instanceof s.Observable) t.call(this, r, e);else {
            if (t.call(this), this.WebSocketCtor = c.root.WebSocket, this._output = new o.Subject(), "string" == typeof e ? this.url = e : d.assign(this, e), !this.WebSocketCtor) throw new Error("no WebSocket constructor can be found");
            this.destination = new a.ReplaySubject();
          }
        }
        return n(e, t), e.prototype.resultSelector = function (t) {
          return JSON.parse(t.data);
        }, e.create = function (t) {
          return new e(t);
        }, e.prototype.lift = function (t) {
          var r = new e(this, this.destination);
          return r.operator = t, r;
        }, e.prototype._resetState = function () {
          this.socket = null, this.source || (this.destination = new a.ReplaySubject()), this._output = new o.Subject();
        }, e.prototype.multiplex = function (t, e, r) {
          var n = this;
          return new s.Observable(function (o) {
            var i = l.tryCatch(t)();
            i === f.errorObject ? o.error(f.errorObject.e) : n.next(i);
            var s = n.subscribe(function (t) {
              var e = l.tryCatch(r)(t);
              e === f.errorObject ? o.error(f.errorObject.e) : e && o.next(t);
            }, function (t) {
              return o.error(t);
            }, function () {
              return o.complete();
            });
            return function () {
              var t = l.tryCatch(e)();
              t === f.errorObject ? o.error(f.errorObject.e) : n.next(t), s.unsubscribe();
            };
          });
        }, e.prototype._connectSocket = function () {
          var t = this,
            e = this.WebSocketCtor,
            r = this._output,
            n = null;
          try {
            n = this.protocol ? new e(this.url, this.protocol) : new e(this.url), this.socket = n, this.binaryType && (this.socket.binaryType = this.binaryType);
          } catch (t) {
            return void r.error(t);
          }
          var o = new u.Subscription(function () {
            t.socket = null, n && 1 === n.readyState && n.close();
          });
          n.onopen = function (e) {
            var s = t.openObserver;
            s && s.next(e);
            var u = t.destination;
            t.destination = i.Subscriber.create(function (t) {
              return 1 === n.readyState && n.send(t);
            }, function (e) {
              var o = t.closingObserver;
              o && o.next(void 0), e && e.code ? n.close(e.code, e.reason) : r.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }")), t._resetState();
            }, function () {
              var e = t.closingObserver;
              e && e.next(void 0), n.close(), t._resetState();
            }), u && u instanceof a.ReplaySubject && o.add(u.subscribe(t.destination));
          }, n.onerror = function (e) {
            t._resetState(), r.error(e);
          }, n.onclose = function (e) {
            t._resetState();
            var n = t.closeObserver;
            n && n.next(e), e.wasClean ? r.complete() : r.error(e);
          }, n.onmessage = function (e) {
            var n = l.tryCatch(t.resultSelector)(e);
            n === f.errorObject ? r.error(f.errorObject.e) : r.next(n);
          };
        }, e.prototype._subscribe = function (t) {
          var e = this,
            r = this.source;
          if (r) return r.subscribe(t);
          this.socket || this._connectSocket();
          var n = new u.Subscription();
          return n.add(this._output.subscribe(t)), n.add(function () {
            var t = e.socket;
            0 === e._output.observers.length && (t && 1 === t.readyState && t.close(), e._resetState());
          }), n;
        }, e.prototype.unsubscribe = function () {
          var e = this,
            r = e.source,
            n = e.socket;
          n && 1 === n.readyState && (n.close(), this._resetState()), t.prototype.unsubscribe.call(this), r || (this.destination = new a.ReplaySubject());
        }, e;
      }(o.AnonymousSubject);
    e.WebSocketSubject = h;
  }, function (t, e) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (r = window);
    }
    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      if (t) {
        if (t instanceof o.Subscriber) return t;
        if (t[i.rxSubscriber]) return t[i.rxSubscriber]();
      }
      return t || e || r ? new o.Subscriber(t, e, r) : new o.Subscriber(s.empty);
    }
    var o = r(4),
      i = r(35),
      s = r(60);
    e.toSubscriber = n;
  }, function (t, e, r) {
    "use strict";

    e.isArray = Array.isArray || function (t) {
      return t && "number" == typeof t.length;
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return null != t && "object" == typeof t;
    }
    e.isObject = n;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = function (t) {
        function e(e) {
          t.call(this), this.errors = e;
          var r = Error.call(this, e ? e.length + " errors occurred during unsubscription:\n  " + e.map(function (t, e) {
            return e + 1 + ") " + t.toString();
          }).join("\n  ") : "");
          this.name = r.name = "UnsubscriptionError", this.stack = r.stack, this.message = r.message;
        }
        return n(e, t), e;
      }(Error);
    e.UnsubscriptionError = o;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e,
        r = t.Symbol;
      return "function" == typeof r ? r.observable ? e = r.observable : (e = r("observable"), r.observable = e) : e = "@@observable", e;
    }
    var o = r(13);
    e.getSymbolObservable = n, e.observable = n(o.root), e.$$observable = e.observable;
  }, function (t, e, r) {
    "use strict";

    function n() {
      for (var t = [], e = 0; e < arguments.length; e++) t[e - 0] = arguments[e];
      return o(t);
    }
    function o(t) {
      return t ? 1 === t.length ? t[0] : function (e) {
        return t.reduce(function (t, e) {
          return e(t);
        }, e);
      } : i.noop;
    }
    var i = r(105);
    e.pipe = n, e.pipeFromArray = o;
  }, function (t, e, r) {
    "use strict";

    function n() {}
    e.noop = n;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(9),
      i = r(107),
      s = r(14),
      u = r(114),
      c = r(61),
      a = r(62),
      l = function (t) {
        function e(e, r, n) {
          void 0 === e && (e = Number.POSITIVE_INFINITY), void 0 === r && (r = Number.POSITIVE_INFINITY), t.call(this), this.scheduler = n, this._events = [], this._bufferSize = e < 1 ? 1 : e, this._windowTime = r < 1 ? 1 : r;
        }
        return n(e, t), e.prototype.next = function (e) {
          var r = this._getNow();
          this._events.push(new f(r, e)), this._trimBufferThenGetEvents(), t.prototype.next.call(this, e);
        }, e.prototype._subscribe = function (t) {
          var e,
            r = this._trimBufferThenGetEvents(),
            n = this.scheduler;
          if (this.closed) throw new c.ObjectUnsubscribedError();
          this.hasError ? e = s.Subscription.EMPTY : this.isStopped ? e = s.Subscription.EMPTY : (this.observers.push(t), e = new a.SubjectSubscription(this, t)), n && t.add(t = new u.ObserveOnSubscriber(t, n));
          for (var o = r.length, i = 0; i < o && !t.closed; i++) t.next(r[i].value);
          return this.hasError ? t.error(this.thrownError) : this.isStopped && t.complete(), e;
        }, e.prototype._getNow = function () {
          return (this.scheduler || i.queue).now();
        }, e.prototype._trimBufferThenGetEvents = function () {
          for (var t = this._getNow(), e = this._bufferSize, r = this._windowTime, n = this._events, o = n.length, i = 0; i < o && !(t - n[i].time < r);) i++;
          return o > e && (i = Math.max(i, o - e)), i > 0 && n.splice(0, i), n;
        }, e;
      }(o.Subject);
    e.ReplaySubject = l;
    var f = function () {
      function t(t, e) {
        this.time = t, this.value = e;
      }
      return t;
    }();
  }, function (t, e, r) {
    "use strict";

    var n = r(108),
      o = r(111);
    e.queue = new o.QueueScheduler(n.QueueAction);
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(109),
      i = function (t) {
        function e(e, r) {
          t.call(this, e, r), this.scheduler = e, this.work = r;
        }
        return n(e, t), e.prototype.schedule = function (e, r) {
          return void 0 === r && (r = 0), r > 0 ? t.prototype.schedule.call(this, e, r) : (this.delay = r, this.state = e, this.scheduler.flush(this), this);
        }, e.prototype.execute = function (e, r) {
          return r > 0 || this.closed ? t.prototype.execute.call(this, e, r) : this._execute(e, r);
        }, e.prototype.requestAsyncId = function (e, r, n) {
          return void 0 === n && (n = 0), null !== n && n > 0 || null === n && this.delay > 0 ? t.prototype.requestAsyncId.call(this, e, r, n) : e.flush(this);
        }, e;
      }(o.AsyncAction);
    e.QueueAction = i;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(13),
      i = r(110),
      s = function (t) {
        function e(e, r) {
          t.call(this, e, r), this.scheduler = e, this.pending = !1, this.work = r;
        }
        return n(e, t), e.prototype.schedule = function (t, e) {
          if (void 0 === e && (e = 0), this.closed) return this;
          this.state = t, this.pending = !0;
          var r = this.id,
            n = this.scheduler;
          return null != r && (this.id = this.recycleAsyncId(n, r, e)), this.delay = e, this.id = this.id || this.requestAsyncId(n, this.id, e), this;
        }, e.prototype.requestAsyncId = function (t, e, r) {
          return void 0 === r && (r = 0), o.root.setInterval(t.flush.bind(t, this), r);
        }, e.prototype.recycleAsyncId = function (t, e, r) {
          return void 0 === r && (r = 0), null !== r && this.delay === r && !1 === this.pending ? e : o.root.clearInterval(e) && void 0 || void 0;
        }, e.prototype.execute = function (t, e) {
          if (this.closed) return new Error("executing a cancelled action");
          this.pending = !1;
          var r = this._execute(t, e);
          if (r) return r;
          !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
        }, e.prototype._execute = function (t, e) {
          var r = !1,
            n = void 0;
          try {
            this.work(t);
          } catch (t) {
            r = !0, n = !!t && t || new Error(t);
          }
          if (r) return this.unsubscribe(), n;
        }, e.prototype._unsubscribe = function () {
          var t = this.id,
            e = this.scheduler,
            r = e.actions,
            n = r.indexOf(this);
          this.work = null, this.state = null, this.pending = !1, this.scheduler = null, -1 !== n && r.splice(n, 1), null != t && (this.id = this.recycleAsyncId(e, t, null)), this.delay = null;
        }, e;
      }(i.Action);
    e.AsyncAction = s;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(14),
      i = function (t) {
        function e(e, r) {
          t.call(this);
        }
        return n(e, t), e.prototype.schedule = function (t, e) {
          return void 0 === e && (e = 0), this;
        }, e;
      }(o.Subscription);
    e.Action = i;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(112),
      i = function (t) {
        function e() {
          t.apply(this, arguments);
        }
        return n(e, t), e;
      }(o.AsyncScheduler);
    e.QueueScheduler = i;
  }, function (t, e, r) {
    "use strict";

    var n = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      o = r(113),
      i = function (t) {
        function e() {
          t.apply(this, arguments), this.actions = [], this.active = !1, this.scheduled = void 0;
        }
        return n(e, t), e.prototype.flush = function (t) {
          var e = this.actions;
          if (this.active) return void e.push(t);
          var r;
          this.active = !0;
          do {
            if (r = t.execute(t.state, t.delay)) break;
          } while (t = e.shift());
          if (this.active = !1, r) {
            for (; t = e.shift();) t.unsubscribe();
            throw r;
          }
        }, e;
      }(o.Scheduler);
    e.AsyncScheduler = i;
  }, function (t, e, r) {
    "use strict";

    var n = function () {
      function t(e, r) {
        void 0 === r && (r = t.now), this.SchedulerAction = e, this.now = r;
      }
      return t.prototype.schedule = function (t, e, r) {
        return void 0 === e && (e = 0), new this.SchedulerAction(this, t).schedule(r, e);
      }, t.now = Date.now ? Date.now : function () {
        return +new Date();
      }, t;
    }();
    e.Scheduler = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return void 0 === e && (e = 0), function (r) {
        return r.lift(new u(t, e));
      };
    }
    var o = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      i = r(4),
      s = r(115);
    e.observeOn = n;
    var u = function () {
      function t(t, e) {
        void 0 === e && (e = 0), this.scheduler = t, this.delay = e;
      }
      return t.prototype.call = function (t, e) {
        return e.subscribe(new c(t, this.scheduler, this.delay));
      }, t;
    }();
    e.ObserveOnOperator = u;
    var c = function (t) {
      function e(e, r, n) {
        void 0 === n && (n = 0), t.call(this, e), this.scheduler = r, this.delay = n;
      }
      return o(e, t), e.dispatch = function (t) {
        var e = t.notification,
          r = t.destination;
        e.observe(r), this.unsubscribe();
      }, e.prototype.scheduleMessage = function (t) {
        this.add(this.scheduler.schedule(e.dispatch, this.delay, new a(t, this.destination)));
      }, e.prototype._next = function (t) {
        this.scheduleMessage(s.Notification.createNext(t));
      }, e.prototype._error = function (t) {
        this.scheduleMessage(s.Notification.createError(t));
      }, e.prototype._complete = function () {
        this.scheduleMessage(s.Notification.createComplete());
      }, e;
    }(i.Subscriber);
    e.ObserveOnSubscriber = c;
    var a = function () {
      function t(t, e) {
        this.notification = t, this.destination = e;
      }
      return t;
    }();
    e.ObserveOnMessage = a;
  }, function (t, e, r) {
    "use strict";

    var n = r(5),
      o = function () {
        function t(t, e, r) {
          this.kind = t, this.value = e, this.error = r, this.hasValue = "N" === t;
        }
        return t.prototype.observe = function (t) {
          switch (this.kind) {
            case "N":
              return t.next && t.next(this.value);
            case "E":
              return t.error && t.error(this.error);
            case "C":
              return t.complete && t.complete();
          }
        }, t.prototype.do = function (t, e, r) {
          switch (this.kind) {
            case "N":
              return t && t(this.value);
            case "E":
              return e && e(this.error);
            case "C":
              return r && r();
          }
        }, t.prototype.accept = function (t, e, r) {
          return t && "function" == typeof t.next ? this.observe(t) : this.do(t, e, r);
        }, t.prototype.toObservable = function () {
          switch (this.kind) {
            case "N":
              return n.Observable.of(this.value);
            case "E":
              return n.Observable.throw(this.error);
            case "C":
              return n.Observable.empty();
          }
          throw new Error("unexpected notification kind value");
        }, t.createNext = function (e) {
          return void 0 !== e ? new t("N", e) : t.undefinedValueNotification;
        }, t.createError = function (e) {
          return new t("E", void 0, e);
        }, t.createComplete = function () {
          return t.completeNotification;
        }, t.completeNotification = new t("C"), t.undefinedValueNotification = new t("N", void 0), t;
      }();
    e.Notification = o;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
      for (var n = e.length, o = 0; o < n; o++) {
        var i = e[o];
        for (var s in i) i.hasOwnProperty(s) && (t[s] = i[s]);
      }
      return t;
    }
    function o(t) {
      return t.Object.assign || n;
    }
    var i = r(13);
    e.assignImpl = n, e.getAssign = o, e.assign = o(i.root);
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.OrderEventSubject = e.AccountEventsSubject = e.TradesSubject = e.Level2Subject = e.Level1Subject = void 0;
    var o = r(118),
      i = n(o),
      s = r(130),
      u = n(s),
      c = r(131),
      a = n(c),
      l = r(132),
      f = n(l),
      d = r(133),
      h = n(d);
    e.Level1Subject = i.default, e.Level2Subject = u.default, e.TradesSubject = a.default, e.AccountEventsSubject = f.default, e.OrderEventSubject = h.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = r(9),
      s = r(4),
      u = r(5);
    r(15);
    var c = r(10),
      a = function t(e) {
        var r = this;
        (0, o.default)(this, t), this.level1InternalIds = [], this.observer = s.Subscriber.create(function (t) {
          r.level1InternalIds.push(t.instrumentId), e.subscribeLevel1(t.instrumentId, t.callback);
        }, function (t) {
          return console.log(t);
        }, function () {
          return console.log("complete");
        }), this.observable = u.Observable.create(function (t) {
          return e.ws.filter(function (t) {
            return "Level1UpdateEvent" === t.n;
          }).subscribe(function (e) {
            var r = JSON.parse(e.o);
            t.next(new c.Level1(r));
          }), function (t) {
            e.level1.level1InternalIds.forEach(function (t) {
              return e.unsubscribeLevel1(t);
            });
          };
        });
        var n = i.Subject.create(this.observer, this.observable);
        return n.level1InternalIds = this.level1InternalIds, n;
      };
    e.default = a, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return o.filter(t, e)(this);
    }
    var o = r(120);
    e.filter = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return function (r) {
        return r.lift(new s(t, e));
      };
    }
    var o = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      i = r(4);
    e.filter = n;
    var s = function () {
        function t(t, e) {
          this.predicate = t, this.thisArg = e;
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new u(t, this.predicate, this.thisArg));
        }, t;
      }(),
      u = function (t) {
        function e(e, r, n) {
          t.call(this, e), this.predicate = r, this.thisArg = n, this.count = 0;
        }
        return o(e, t), e.prototype._next = function (t) {
          var e;
          try {
            e = this.predicate.call(this.thisArg, t, this.count++);
          } catch (t) {
            return void this.destination.error(t);
          }
          e && this.destination.next(t);
        }, e;
      }(i.Subscriber);
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = r(36),
      i = n(o),
      s = r(3),
      u = n(s),
      c = function t(e) {
        (0, u.default)(this, t), (0, i.default)(this, e);
      };
    e.default = c, t.exports = e.default;
  }, function (t, e, r) {
    r(123), t.exports = r(1).Object.assign;
  }, function (t, e, r) {
    var n = r(6);
    n(n.S + n.F, "Object", {
      assign: r(124)
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(8),
      o = r(41),
      i = r(125),
      s = r(126),
      u = r(32),
      c = r(42),
      a = Object.assign;
    t.exports = !a || r(25)(function () {
      var t = {},
        e = {},
        r = Symbol(),
        n = "abcdefghijklmnopqrst";
      return t[r] = 7, n.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != a({}, t)[r] || Object.keys(a({}, e)).join("") != n;
    }) ? function (t, e) {
      for (var r = u(t), a = arguments.length, l = 1, f = i.f, d = s.f; a > l;) for (var h, p = c(arguments[l++]), v = f ? o(p).concat(f(p)) : o(p), b = v.length, y = 0; b > y;) h = v[y++], n && !d.call(p, h) || (r[h] = p[h]);
      return r;
    } : a;
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = function t(e) {
        (0, o.default)(this, t), this.UpdateId = e[0], this.NumberOfAccounts = e[1], this.UpdateDateTime = e[2], this.ActionType = e[3], this.LastTradePrice = e[4], this.NumberOfOrders = e[5], this.Price = e[6], this.ProductPairCode = e[7], this.Quantity = e[8], this.Side = e[9];
      };
    e.default = i, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = function t(e) {
        (0, o.default)(this, t), this.TradeId = e[0], this.InstrumentId = e[1], this.Quantity = e[2], this.Price = e[3], this.Order1Id = e[4], this.Order2Id = e[5], this.Timestamp = e[6], this.Direction = e[7], this.TakerSide = e[8];
      };
    e.default = i, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = r(36),
      i = n(o),
      s = r(3),
      u = n(s),
      c = function t(e) {
        (0, u.default)(this, t), (0, i.default)(this, e);
      };
    e.default = c, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = r(9),
      s = r(4),
      u = r(5);
    r(15);
    var c = r(10),
      a = function t(e) {
        var r = this;
        (0, o.default)(this, t), this.level2InternalIds = [], this.observer = s.Subscriber.create(function (t) {
          r.level2InternalIds.push(t.instrumentId), e.subscribeLevel2(t.instrumentId, t.depth, t.callback);
        }, function (t) {
          return console.log(t);
        }, function () {
          return console.log("complete");
        }), this.observable = u.Observable.create(function (t) {
          return e.ws.filter(function (t) {
            return "Level2UpdateEvent" === t.n;
          }).subscribe(function (e) {
            var r = JSON.parse(e.o),
              n = Array.isArray(r) ? r.map(function (t) {
                return new c.Level2(t);
              }) : [];
            t.next(n);
          }), function (t) {
            e.level2.level2InternalIds.forEach(function (t) {
              return e.unsubscribeLevel2(t);
            });
          };
        });
        var n = i.Subject.create(this.observer, this.observable);
        return n.level2InternalIds = this.level2InternalIds, n;
      };
    e.default = a, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = r(9),
      s = r(4),
      u = r(5);
    r(15);
    var c = r(10),
      a = function t(e) {
        var r = this;
        (0, o.default)(this, t), this.tradesInternalId = [], this.observer = s.Subscriber.create(function (t) {
          r.tradesInternalId.push(t.instrumentId), e.subscribeTrades(t.instrumentId, t.history, t.callback);
        }, function (t) {
          return console.log(t);
        }, function () {
          return console.log("complete");
        }), this.observable = u.Observable.create(function (t) {
          return e.ws.filter(function (t) {
            return "TradeDataUpdateEvent" === t.n;
          }).subscribe(function (e) {
            JSON.parse(e.o).forEach(function (e) {
              return t.next(new c.Trade(e));
            });
          }), function (t) {
            e.trades.tradesInternalId.forEach(function (t) {
              return e.unsubscribeTrades(t);
            });
          };
        });
        var n = i.Subject.create(this.observer, this.observable);
        return n.tradesInternalId = this.tradesInternalId, n;
      };
    e.default = a, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = r(9),
      s = r(4),
      u = r(5);
    r(15);
    var c = function t(e) {
      return (0, o.default)(this, t), this.observer = s.Subscriber.create(function (t) {}, function (t) {
        return console.log(t);
      }, function () {
        return console.log("complete");
      }), this.observable = u.Observable.create(function (t) {
        e.ws.filter(function (t) {
          return "AccountEvent" === t.n;
        }).subscribe(function (e) {
          t.next(e);
        });
      }), i.Subject.create(this.observer, this.observable);
    };
    e.default = c, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(3),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = r(9),
      s = r(4),
      u = r(5);
    r(15), r(134);
    var c = r(10),
      a = function t(e) {
        return (0, o.default)(this, t), this.observer = s.Subscriber.create(function (t) {}, function (t) {
          return console.log(t);
        }, function () {
          return console.log("complete");
        }), this.observable = u.Observable.create(function (t) {
          e.ws.filter(function (t) {
            return "OrderStateEvent" === t.n;
          }).subscribe(function (e) {
            var r = JSON.parse(e.o);
            t.next(new c.Order(r));
          });
        }), i.Subject.create(this.observer, this.observable);
      };
    e.default = a, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    var n = r(5),
      o = r(135);
    n.Observable.prototype.do = o._do, n.Observable.prototype._do = o._do;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      return o.tap(t, e, r)(this);
    }
    var o = r(136);
    e._do = n;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      return function (n) {
        return n.lift(new s(t, e, r));
      };
    }
    var o = this && this.__extends || function (t, e) {
        function r() {
          this.constructor = t;
        }
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      },
      i = r(4);
    e.tap = n;
    var s = function () {
        function t(t, e, r) {
          this.nextOrObserver = t, this.error = e, this.complete = r;
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new u(t, this.nextOrObserver, this.error, this.complete));
        }, t;
      }(),
      u = function (t) {
        function e(e, r, n, o) {
          t.call(this, e);
          var s = new i.Subscriber(r, n, o);
          s.syncErrorThrowable = !0, this.add(s), this.safeSubscriber = s;
        }
        return o(e, t), e.prototype._next = function (t) {
          var e = this.safeSubscriber;
          e.next(t), e.syncErrorThrown ? this.destination.error(e.syncErrorValue) : this.destination.next(t);
        }, e.prototype._error = function (t) {
          var e = this.safeSubscriber;
          e.error(t), e.syncErrorThrown ? this.destination.error(e.syncErrorValue) : this.destination.error(t);
        }, e.prototype._complete = function () {
          var t = this.safeSubscriber;
          t.complete(), t.syncErrorThrown ? this.destination.error(t.syncErrorValue) : this.destination.complete();
        }, e;
      }(i.Subscriber);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.endpoints = void 0;
    var n = r(138),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      i = ["AccountOperator", "AccountReadOnly", "Activate2FA", "AddAccount", "AddAccountHold", "AddBalanceReconciliationInfo", "AddDepositTicketAttachment", "AddEditAccountBadge", "AddEditExchange", "AddEditExchangeInstrument", "AddEditOMS", "AddEditOperatorEmail", "AddEditXPSubscriptionKey", "AddInstrument", "AddInstrumentAttributes", "AddOperator", "AddOperatorConfig", "AddOperatorOMS", "AddProduct", "AddProductAttributes", "AddUserAccount", "AddUserAffiliateTag", "AddUserAPIKey", "AddUserAPIKeyPermission", "AddUserInstrumentPermissions", "AddUserMarketDataPermission", "AddUserPermission", "AddUserProductPermissions", "AddUserReportTicket", "AddVerificationLevelConfig", "AddWithdrawTicketAttachment", "AdminUI", "AM_AddEditAccountAssetInfo", "AM_AddEditAccountProviderInfo", "AM_AddEditAssetInfo", "AM_AddEditUser", "AM_GetAccountAssetDepositInfo", "AM_GetAccountIdByDepositInfo", "AM_GetAccountInfo", "AM_GetAccountProvidersInfoList", "AM_GetAccountProvidersTypeList", "AM_GetAccountTransactions", "AM_GetAllAccountDepositInfo", "AM_GetAllAccounts", "AM_GetAllPending", "AM_GetAssetInfo", "AM_GetAssetInfoList", "AM_GetCurrentSequenceNumber", "AM_GetDefaultAccountProviderInfo", "AM_GetHoldInfo", "AM_GetTransactionsReplay", "AM_GetWithdrawFormTemplate", "AM_GetWithdrawFormTemplateTypes", "AM_SubmitWithdrawForm", "AM_SubscribeToActions", "AM_TransactionSetRequest", "Authenticate2FA", "AuthenticateUser", "CallAccountProviderAdminFunction", "CancelAllOrders", "CancelFailedWithdrawTicket", "CancelOrder", "CancelQuote", "CancelReplaceOrder", "CancelTransferFunds", "CancelUserReport", "CancelWithdraw", "CoinsOAuthAuthenticateUser", "Company", "ConfirmRequestTransferFunds", "ConfirmTransferFunds", "ConfirmUserEmail", "ConfirmWithdraw", "CreateAmlProviderConfig", "CreateAssetManagerWalletTicket", "CreateDepositTicket", "CreateOperatorLoyaltyFeeConfig", "CreateQuote", "CreateServiceInfo", "CreateUser", "CreateValidatorConfig", "CreateWithdrawTicket", "DeleteAmlProviderConfig", "DeleteOperatorLoyaltyFeeConfig", "DeleteServiceInfo", "DeleteValidatorConfig", "DeleteVerificationLevelConfig", "Deposit", "Disable2FA", "DownloadDocument", "DownloadDocumentSlice", "EditInstrumentVerificationLevelConfig", "EditOperatorConfig", "EditVerificationLevelConfig", "EnableGoogle2FA", "EnableXP2FA", "ForceUserLogoff", "General_AddEditAssetManager", "General_GetAssetManagers", "GenerateTradeActivityReport", "GenerateTransactionActivityReport", "GenerateTreasuryActivityReport", "GetAccountBadges", "GetAccountConfig", "GetAccountDepositTransactions", "GetAccountFees", "GetAccountInfo", "GetAccountPositions", "GetAccountProviderAdminFunctions", "GetAccountProviderDetails", "GetAccounts", "GetAccountTrades", "GetAccountTransactions", "GetAccountWithdrawTransactions", "GetAllAccountPositions", "GetAllAssetManagerWalletTickets", "GetAllBadges", "GetAllBalanceReconciliationInfo", "GetAllDepositRequestInfoTemplates", "GetAllDepositTickets", "GetAllOperatorConfigs", "GetAllOperatorLoyaltyFeeConfigs", "GetAllUserGroupPermissions", "GetAllUserGroups", "GetAllUserInstrumentPermissions", "GetAllUserProductPermissions", "GetAllWithdrawTickets", "GetAmlProviderConfig", "GetAmlProviderConfigsForOms", "GetAssetManagerWalletTicket", "GetAvailablePermissionList", "GetBadgeAccount", "GetBalanceReconciliationInfo", "GetBook", "GetDepositInfo", "GetDepositRequestInfoTemplate", "GetDeposits", "GetDepositTicket", "GetDepositTicketAttachment", "GetDepositTickets", "GetDistributions", "GetEarliestTickTime", "GetEmailSenderParams", "GetExchanges", "GetExchangeServiceIds", "GetExchangeStopOrders", "GetExchangeWorkingOrders", "GetInstrument", "GetInstrumentAttributes", "GetInstruments", "GetInstrumentVerificationLevelConfigs", "GetL2Snapshot", "GetLevel1", "GetLoggedInUserBySessionToken", "GetMarketSyncState", "GetOMS", "GetOMSAccountConfigKeys", "GetOMSFees", "GetOMSs", "GetOMSStatistics", "GetOMSUserConfigKeys", "GetOMSUsers", "GetOMSUsersWithPermission", "GetOMSWithdrawFees", "GetOpenHolds", "GetOpenOrders", "GetOpenQuotes", "GetOpenTradeReports", "GetOpenWithdrawHolds", "GetOperator", "GetOperator2FAConfig", "GetOperator2FAConfigs", "GetOperatorById", "GetOperatorConfig", "GetOperatorEmail", "GetOperatorEmails", "GetOperatorLoyaltyFeeConfig", "GetOperatorLoyaltyFeeConfigs", "GetOperatorLoyaltyFeeConfigsForOms", "GetOperatorOMSList", "GetOperators", "GetOperatorUsers", "GetOrderFee", "GetOrderHistory", "GetOrderHistoryByOrderId", "GetOrdersHistory", "GetOrderStatus", "GetProduct", "GetProductAttributes", "GetProducts", "GetRecentAffiliateRegistrations", "GetRequestTransfer", "GetRequestTransferRequestsReceived", "GetRequestTransferRequestsRequested", "GetRequestTransfers", "GetServerKVPStats", "GetServerStats", "GetServiceInfo", "GetServiceInfos", "GetTickerHistory", "GetTradesHistory", "GetTransfer", "GetTransfers", "GetTransfersReceived", "GetTreasuryProductsForAccount", "GetUnderReviewManualKYCUsers", "GetUserAccountInfos", "GetUserAccounts", "GetUserAffiliateCount", "GetUserAffiliates", "GetUserAffiliateTag", "GetUserAPIKeys", "GetUserConfig", "GetUserGroupPermissions", "GetUserInfo", "GetUserMarketDataPermissions", "GetUserPermissions", "GetUserReportTickets", "GetUserReportTicketsByStatus", "GetUserReportWriterResultRecords", "GetValidatorConfig", "GetValidatorConfigs", "GetVenueInstruments", "GetVerificationLevelConfigs", "GetWithdrawFee", "GetWithdraws", "GetWithdrawTemplate", "GetWithdrawTemplateTypes", "GetWithdrawTicket", "GetWithdrawTicketAttachment", "GetWithdrawTickets", "GetXPSubscriptionKey", "Level1MarketData", "Level2MarketData", "MarketHalt", "MarketMaker", "MarketPause", "MarketReopen", "MarketResume", "MarketReSync", "MigrateUser", "ModifyOrder", "NoOperation", "NoOperationFromGW", "Operator", "Ping", "public", "Public", "QueryRemoteServices", "RegisterUser", "RejectRequestTransferFunds", "Remarketer", "RemoveAccountConfig", "RemoveInstrumentAttributes", "RemoveOperatorConfig", "RemoveOperatorEmail", "RemoveOperatorOMS", "RemoveOperatorUser", "RemoveProductAttributes", "RemoveUserAccount", "RemoveUserAPIKey", "RemoveUserAPIKeyPermission", "RemoveUserConfig", "RemoveUserInstrumentPermissions", "RemoveUserMarketDataPermission", "RemoveUserProductPermissions", "RemoveUserReportTicket", "RemoveXPSubscriptionKey", "RequestTransferFunds", "ResetAllMarketDatas", "ResetHolds", "ResetMarketData", "ResetPassword", "ResetPassword2", "ResetTradingLimits", "ResetTreasuryLimits", "ResubmitFailedWithdrawTicket", "ReverseAccountHold", "ReverseWithdrawHold", "RevokeUserPermission", "ScheduleTradeActivityReport", "ScheduleTransactionActivityReport", "ScheduleTreasuryActivityReport", "SendAssetManagerSequenceReset", "SendEmail", "SendEndOfDay", "SendExchangeOrderStateEvent", "SendOrder", "SetAccountConfig", "SetAccountPendingDeposit", "SetDefaultOperatorOMS", "SetDistribution", "SetOMSAccountConfigKey", "SetOMSFee", "SetOMSUserConfigKey", "SetOMSWithdrawFee", "SetOperator2FAConfig", "SetOperatorEmail", "SetUserConfig", "SetUserGroupPermission", "SetUserInfo", "SetUserVerificationLevel", "SubmitAccountLedgerEntry", "SubmitBlockTrade", "SubmitDepositTicketComment", "SubmitWithdrawTicketComment", "SubscribeAccountEvents", "SubscribeLevel1", "SubscribeLevel2", "SubscribeTicker", "SubscribeTrades", "SUPERUSER", "TakeSnapshot", "TakeSnapshotAssetManager", "TakeSnapshotMarketData", "TakeSnapshotMatchingEngine", "TestMatchingEngineSleep", "Trading", "TransferFunds", "UnSubscribeLevel1", "UnsubscribeLevel2", "UnSubscribeTicker", "UnSubscribeTrades", "UpdateAccount", "UpdateAmlProviderConfig", "UpdateAssetManagerWalletTicket", "UpdateDepositTicket", "UpdateInstrument", "UpdateOperator", "UpdateOperatorLoyaltyFeeConfig", "UpdateProduct", "UpdateQuote", "UpdateServiceInfo", "UpdateUserAffiliateTag", "UpdateValidatorConfig", "UpdateWithdrawTicket", "UserOperator", "ValidateUserRegistration", "WebAuthenticateUser", "Withdraw"],
      s = ["SUPERUSER", "AdminUI", "UserOperator", "Trading", "Withdraw", "Deposit", "AccountOperator", "Remarketer"],
      u = ["RegisterNewUser", "ResendVerificationEmail"];
    e.endpoints = [].concat((0, o.default)(i.filter(function (t) {
      return !s.includes(t);
    })), u);
  }, function (t, e, r) {
    "use strict";

    e.__esModule = !0;
    var n = r(139),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n);
    e.default = function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = Array(t.length); e < t.length; e++) r[e] = t[e];
        return r;
      }
      return (0, o.default)(t);
    };
  }, function (t, e, r) {
    t.exports = {
      default: r(140),
      __esModule: !0
    };
  }, function (t, e, r) {
    r(39), r(141), t.exports = r(1).Array.from;
  }, function (t, e, r) {
    "use strict";

    var n = r(16),
      o = r(6),
      i = r(32),
      s = r(48),
      u = r(49),
      c = r(29),
      a = r(142),
      l = r(50);
    o(o.S + o.F * !r(55)(function (t) {
      Array.from(t);
    }), "Array", {
      from: function from(t) {
        var e,
          r,
          o,
          f,
          d = i(t),
          h = "function" == typeof this ? this : Array,
          p = arguments.length,
          v = p > 1 ? arguments[1] : void 0,
          b = void 0 !== v,
          y = 0,
          _ = l(d);
        if (b && (v = n(v, p > 2 ? arguments[2] : void 0, 2)), void 0 == _ || h == Array && u(_)) for (e = c(d.length), r = new h(e); e > y; y++) a(r, y, b ? v(d[y], y) : d[y]);else for (f = _.call(d), r = new h(); !(o = f.next()).done; y++) a(r, y, b ? s(f, v, [o.value, y], !0) : o.value);
        return r.length = y, r;
      }
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(12),
      o = r(27);
    t.exports = function (t, e, r) {
      e in t ? n.f(t, e, o(0, r)) : t[e] = r;
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = r(144),
      i = n(o),
      s = r(145),
      u = n(s),
      c = r(146),
      a = n(c),
      l = r(147),
      f = n(l),
      d = r(148),
      h = n(d),
      p = r(149),
      v = n(p),
      b = r(150),
      y = n(b),
      _ = r(151),
      O = n(_),
      S = r(152),
      g = n(S),
      m = r(153),
      A = n(m),
      w = r(154),
      P = n(w),
      x = r(155),
      I = n(x),
      C = r(156),
      M = n(C),
      T = r(157),
      G = n(T),
      j = r(158),
      E = n(j),
      R = r(159),
      k = n(R),
      U = r(160),
      L = n(U),
      F = r(161),
      D = n(F),
      W = r(162),
      N = n(W),
      q = r(163),
      V = n(q),
      B = r(164),
      H = n(B),
      K = r(165),
      Q = n(K),
      J = r(166),
      X = n(J),
      Y = r(167),
      z = n(Y),
      $ = r(168),
      Z = n($),
      tt = r(169),
      et = n(tt),
      rt = r(170),
      nt = n(rt),
      ot = r(171),
      it = n(ot),
      st = r(172),
      ut = n(st),
      ct = r(173),
      at = n(ct),
      lt = r(174),
      ft = n(lt);
    e.default = {
      getOMSs: i.default,
      getProducts: u.default,
      getInstruments: a.default,
      authenticateUser: f.default,
      webAuthenticateUser: h.default,
      subscribeLevel1: v.default,
      subscribeLevel2: y.default,
      getUserInfo: O.default,
      getUserAccounts: g.default,
      getAccountInfo: A.default,
      getAccountTransactions: P.default,
      getRequestTransfers: I.default,
      getWithdrawTickets: M.default,
      getOpenOrders: G.default,
      getOpenTradeReports: E.default,
      getOpenQuotes: k.default,
      getAccountPositions: L.default,
      getOrderHistory: D.default,
      getAccountTrades: N.default,
      unsubscribeLevel1: V.default,
      unsubscribeLevel2: H.default,
      subscribeTrades: Q.default,
      unsubscribeTrades: X.default,
      subscribeAccountEvents: z.default,
      sendOrder: Z.default,
      cancelOrder: et.default,
      cancelAllOrders: nt.default,
      getUserPermissions: it.default,
      getUserAPIKeys: ut.default,
      getUserConfig: at.default,
      getOrderFee: ft.default
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
        e = arguments[1];
      this.RPCCall("GetOMSs", {
        OperatorId: t
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      this.RPCCall("GetProducts", {
        OMSId: this.omsId
      }, t);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      this.RPCCall("GetInstruments", {
        OMSId: this.omsId
      }, t);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      var n = this,
        o = {
          UserName: t,
          Password: e
        };
      return this.isAuthenticated ? console.log("Already authenticated") : this.RPCCall("AuthenticateUser", o, function (t) {
        var e = JSON.parse(t.o);
        e.Authenticated && (n.isAuthenticated = !0, n.accountId = e.User.AccountId), r(e);
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = this,
        n = t.SessionToken,
        o = t.username,
        i = t.password,
        s = t.authCode,
        u = {};
      return n ? u.SessionToken = n : (u.UserName = o, u.Password = i), s && (u.authCode = s), this.RPCCall("WebAuthenticateUser", u, function (t) {
        r.userId = t.UserId, e(t);
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = {
        OMSId: 1,
        InstrumentId: t
      };
      this.RPCCall("SubscribeLevel1", r, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      var n = {
        OMSId: 1,
        InstrumentId: t,
        Depth: e
      };
      this.RPCCall("SubscribeLevel2", n, function (t) {
        var e = JSON.parse(t.o),
          n = Array.isArray(e) ? e.map(function (t) {
            return new o.Level2(t);
          }) : [];
        r(n);
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = r(10);
    e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.userId,
        e = arguments[1];
      this.RPCCall("GetUserInfo", {
        UserId: t
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      this.RPCCall("GetUserAccounts", {
        OMSId: t
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = t.AccountId,
        n = t.OMSId;
      this.RPCCall("GetAccountInfo", {
        AccountId: r,
        OMSId: n
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments[2],
        n = arguments[3],
        o = arguments[4];
      this.RPCCall("GetAccountTransactions", {
        AccountId: t,
        OMSId: e,
        StartIndex: r,
        Count: n
      }, o);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
        e = arguments[1],
        r = arguments[2],
        n = arguments[3],
        o = arguments[4];
      this.RPCCall("GetRequestTransfers", {
        OMSId: t,
        OperatorId: e,
        PayerAccountId: r,
        Status: n
      }, o);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      this.RPCCall("GetWithdrawTickets", {
        OMSId: t,
        AccountId: e
      }, r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.accountId,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments[2];
      this.RPCCall("GetOpenOrders", {
        OMSId: e,
        AccountId: t
      }, r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments[2];
      this.RPCCall("GetOpenTradeReports", {
        AccountId: t,
        OMSId: e
      }, r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
        n = arguments[3];
      this.RPCCall("GetOpenQuotes", {
        AccountId: t,
        InstrumentId: e,
        OMSId: r
      }, n);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.accountId,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments[2];
      this.RPCCall("GetAccountPositions", {
        OMSId: e,
        AccountId: t
      }, r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.accountId,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3,
        n = arguments[3];
      this.RPCCall("GetOrderHistory", {
        OMSId: e,
        AccountId: t,
        Depth: r
      }, n);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.accountId,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
        r = arguments[2];
      this.RPCCall("GetAccountTrades", {
        OMSId: e,
        AccountId: t
      }, r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = {
        OMSId: 1,
        InstrumentId: t
      };
      this.RPCCall("UnsubscribeLevel1", r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = {
        OMSId: 1,
        InstrumentId: t
      };
      this.RPCCall("UnsubscribeLevel2", r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e, r) {
      var n = {
        OMSId: 1,
        InstrumentId: t,
        IncludeLastCount: e
      };
      this.RPCCall("SubscribeTrades", n, function (t) {
        var e = JSON.parse(t.o),
          n = e.map(function (t) {
            return new o.Trade(t);
          });
        r(n);
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = r(10);
    e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      var r = {
        OMSId: 1,
        InstrumentId: t
      };
      this.RPCCall("UnsubscribeTrades", r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.accountId,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.omsId;
      arguments[2];
      this.RPCCall("SubscribeAccountEvents", {
        OMSId: e,
        AccountId: t
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      this.RPCCall("SendOrder", t, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.accountId,
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
        n = arguments[3],
        o = {
          OMSId: r,
          OrderId: t,
          AccountId: e
        };
      this.RPCCall("CancelOrder", o, n);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.accountId,
        r = arguments[2],
        n = arguments[3];
      this.RPCCall("CancelAllOrders", {
        OMSId: t,
        AccountId: e,
        InstrumentId: r
      }, n);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.userId,
        e = arguments[1];
      this.RPCCall("GetUserPermissions", {
        UserId: t
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      this.RPCCall("GetUserAPIKeys", {
        UserId: t
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      this.RPCCall("GetUserConfig", {
        UserId: t
      }, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        e = arguments[1];
      this.RPCCall("GetOrderFee", t, e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.APAD = void 0;
    var o = r(38),
      i = n(o),
      s = r(37),
      u = n(s),
      c = r(36),
      a = n(c),
      l = r(3),
      f = n(l),
      d = r(56),
      h = n(d),
      p = r(57);
    r(15);
    var v = r(176),
      b = r(63),
      y = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "ws://apad-staging-server1.ezx.io:15001",
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              onopen: function onopen(t) {
                return console.log(t);
              },
              onclose: function onclose(t) {
                return console.log(t);
              },
              onerror: function onerror(t) {
                return console.log(t);
              },
              oncomplete: function oncomplete() {
                return console.log("complete");
              }
            };
          (0, f.default)(this, t), this.meshUri = e, this.sessionId = null, this.adminSessionId = null, this.callbacks = {}, this.RPCRegistrations = {}, this.onopen = r.onopen, this.onclose = r.onclose, this.onerror = r.onerror, this.oncomplete = r.oncomplete, this.connect();
        }
        return (0, h.default)(t, [{
          key: "connect",
          value: function value(t) {
            var e = this;
            this.ws && this.ws.isConnected || (this.ws = (0, p.webSocket)({
              url: this.meshUri ? this.meshUri : t,
              WebSocketCtor: b,
              openObserver: {
                next: function next(t) {
                  return e.onopen(t);
                }
              },
              closeObserver: {
                next: function next(t) {
                  return e.onclose(t);
                }
              }
            }), this.ws.binaryType = "arraybuffer", this.ws.filter(function (t) {
              return "RPCReply" === t.MessageType;
            }).subscribe(function (t) {
              e.callbacks[t.RequestUniqueId] && (e.callbacks[t.RequestUniqueId](t), delete e.callbacks[t.RequestUniqueId]);
            }, this.onerror, this.oncomplete));
          }
        }, {
          key: "RPCCall",
          value: function value(t, e) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : console.log,
              n = {},
              o = void 0;
            o = this.sessionId ? (0, a.default)({}, e, {
              sessionId: this.sessionId
            }) : e, n.MessageType = "RPCCall", n.FunctionName = t, n.Parameter = (0, u.default)(o), n.RequestUniqueId = v.UUID.generate(), this.callbacks[n.RequestUniqueId] = r, this.ws.next((0, u.default)(n));
          }
        }, {
          key: "RPCPromise",
          value: function value(t, e) {
            var r = this;
            return new i.default(function (n, o) {
              r.RPCCall(t, e, function (t) {
                n(t);
              });
            });
          }
        }, {
          key: "RegisterRPC",
          value: function value(t, e, r) {
            this.RPCRegistrations[t + "->" + e] = r;
          }
        }, {
          key: "login",
          value: function value(t, e) {
            var r = this;
            this.RPCCall("Login", t, function (t) {
              var n = JSON.parse(t.Parameter).payload.SessionId;
              r.sessionId = n, e ? e(t) : console.log(t);
            });
          }
        }, {
          key: "version",
          value: function value(t) {
            this.RPCCall("Version", {}, t);
          }
        }, {
          key: "eightBall",
          value: function value(t, e) {
            this.RPCCall("EightBall", {
              question: t
            }, e);
          }
        }, {
          key: "createAsset",
          value: function value(t, e) {
            this.RPCCall("CreateAsset", t, e);
          }
        }, {
          key: "issueAsset",
          value: function value(t, e) {
            this.RPCCall("IssueAsset", t, e);
          }
        }, {
          key: "transferAsset",
          value: function value(t, e) {
            this.RPCCall("TransferAsset", t, e);
          }
        }, {
          key: "getAssets",
          value: function value(t) {
            this.RPCCall("GetAssets", {}, t);
          }
        }, {
          key: "updateAccountAddAsset",
          value: function value(t, e) {
            this.RPCCall("UpdateAccountAddAsset", t, e);
          }
        }, {
          key: "getSessionStatus",
          value: function value() {}
        }, {
          key: "createCompany",
          value: function value(t, e, r) {
            this.RPCCall("CreateCompany", {
              companyName: t,
              assetNames: e
            }, r);
          }
        }, {
          key: "createUser",
          value: function value(t, e) {
            this.RPCCall("CreateUser", t, e);
          }
        }, {
          key: "getUsers",
          value: function value(t) {
            this.RPCCall("GetUsers", {}, t);
          }
        }, {
          key: "getCompanies",
          value: function value(t) {
            this.RPCCall("GetCompanies", {}, t);
          }
        }, {
          key: "createUserAccount",
          value: function value() {}
        }, {
          key: "getBlockchainEvents",
          value: function value(t) {
            this.RPCCall("ExploreBlockchain", {}, t);
          }
        }, {
          key: "sendSMS",
          value: function value() {}
        }, {
          key: "sendEmail",
          value: function value() {}
        }, {
          key: "getAccounts",
          value: function value(t) {
            this.RPCCall("GetAccounts", {}, t);
          }
        }, {
          key: "userGetAccountInfo",
          value: function value() {}
        }, {
          key: "userGetTransactions",
          value: function value() {}
        }, {
          key: "userLogin",
          value: function value() {}
        }]), t;
      }();
    e.APAD = y;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }); /**
        * Fast UUID generator, RFC4122 version 4 compliant.
        * @author Jeff Ward (jcward.com).
        * @license MIT license
        * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
        **/
    e.UUID = function () {
      for (var t = {}, e = [], r = 0; r < 256; r++) e[r] = (r < 16 ? "0" : "") + r.toString(16);
      return t.generate = function () {
        var t = 4294967295 * Math.random() | 0,
          r = 4294967295 * Math.random() | 0,
          n = 4294967295 * Math.random() | 0,
          o = 4294967295 * Math.random() | 0;
        return e[255 & t] + e[t >> 8 & 255] + e[t >> 16 & 255] + e[t >> 24 & 255] + "-" + e[255 & r] + e[r >> 8 & 255] + "-" + e[r >> 16 & 15 | 64] + e[r >> 24 & 255] + "-" + e[63 & n | 128] + e[n >> 8 & 255] + "-" + e[n >> 16 & 255] + e[n >> 24 & 255] + e[255 & o] + e[o >> 8 & 255] + e[o >> 16 & 255] + e[o >> 24 & 255];
      }, t;
    }();
  }]);
});